export type ApiOptions = {
    publicationState?: "live" | "preview";
    filters?: Record<string, unknown>;
    populate?: Record<string, unknown>;
};

export enum ResponseSource {
    MEMORY = "memory",
    REDIS = "redis",
    CMS = "cms",
}

export type StrapiEntity<T> = {
    readonly id: number;
    readonly attributes: T;
};

export type StrapiResponse<T> = {
    readonly data: T | null;
    readonly error?: CmsError;
    readonly meta?: CmsMeta;
    source?: ResponseSource;
};

export type CmsMeta = {
    readonly pagination: Pagination;
};

type Pagination = {
    readonly page: number;
    readonly pageSize: number;
    readonly pageCount: number;
    readonly total: number;
};

export enum CmsMediaImageMimetype {
    JPEG = "image/jpeg",
    PNG = "image/png",
    GIF = "image/gif",
    SVG = "image/svg+xml",
    TIFF = "image/tiff",
    TIF = "image/tif",
    ICO = "image/x-icon",
    MSICO = "image/vnd.microsoft.icon",
    DVU = "DVU", // Unknown mimetype: https://discord.com/channels/811989166782021633/1085182388285481034/1085182388285481034
    WEBP = "image/webp",
    AVIF = "image/avif",
}

export type CmsMedia = {
    readonly data: Media;
};

export type CmsMediaArray = {
    readonly data: Media[];
};

export type Media = {
    readonly id: number;
    readonly attributes: MediaAttributes;
};

export type CommonMediaAttributes = {
    readonly name: string;
    readonly ext: string;
    readonly url: string;
    readonly hash: string;
    readonly mime: CmsMediaImageMimetype;
    readonly size: number;
    readonly width: number;
    readonly height: number;
};

export type MediaAttributes = CommonMediaAttributes & {
    readonly alternativeText?: string;
    readonly captions?: string;
    readonly formats?: MediaFormats;
    readonly previewUrl?: string;
    readonly provider: string;
    readonly provider_metadata?: unknown;
    readonly createdAt: Date;
    readonly updatedAt: Date;
};

export type MediaFormats = {
    readonly xlarge?: MediaFormat;
    readonly large?: MediaFormat;
    readonly medium?: MediaFormat;
    readonly small?: MediaFormat;
    readonly logo?: MediaFormat;
    readonly original?: MediaFormat;

    readonly logo_254?: MediaFormat;
    readonly logo_187?: MediaFormat;
    readonly logo_172?: MediaFormat;
    readonly logo_121?: MediaFormat;

    readonly xlarge_webp?: MediaFormat;
    readonly large_webp?: MediaFormat;
    readonly medium_webp?: MediaFormat;
    readonly small_webp?: MediaFormat;
    readonly logo_webp?: MediaFormat;
    readonly original_webp?: MediaFormat;

    readonly logo_254_webp?: MediaFormat;
    readonly logo_187_webp?: MediaFormat;
    readonly logo_172_webp?: MediaFormat;
    readonly logo_121_webp?: MediaFormat;


};

export type MediaResponsiveFormat = {
    src: string;
    width: number | "100vw";
    screenWidth?: number;
}

type MediaFormat = CommonMediaAttributes & {
    readonly path?: string;
};

export type CmsError = {
    readonly status: number;
    readonly name: string;
    readonly message: string;
    readonly details: Record<string, unknown>;
};
